(() => {
  'use strict';

  const REVIEW_ASSET_VERSION = '202607262245';
  const shellScriptUrl = (() => {
    const current = document.currentScript;
    if (current && current.src) return current.src;

    const fallback = Array.from(document.scripts).find((script) =>
      script.src && script.src.includes('iba-market-shell.js')
    );

    return fallback ? fallback.src : '';
  })();

  const utilityItemIds = new Set([
    'item_mb_wis',
    'item_mb_compe',
    'item_mb_sea',
    'item_mb_acc',
    'item_mb_cur',
    'item_mb_lang'
  ]);

  const getUaeAssetUrl = (filename) => {
    if (!shellScriptUrl) return '';

    try {
      const url = new URL(shellScriptUrl, document.baseURI);
      url.pathname = url.pathname.replace(/iba-market-shell\.js$/, filename);
      url.search = '';
      url.hash = '';
      url.searchParams.set('v', REVIEW_ASSET_VERSION);
      return url.toString();
    } catch (error) {
      return '';
    }
  };

  const installUaeMobileMenu = () => {
    const menu = document.querySelector('#menu-mb__ul');
    const template = document.querySelector('#iba-uae-mobile-menu-template');

    if (!menu || !template || menu.dataset.ibaUaeReady === 'true') return false;

    Array.from(menu.children).forEach((item) => {
      if (!(item instanceof HTMLElement)) return;
      if (!utilityItemIds.has(item.id)) {
        item.hidden = true;
        item.setAttribute('aria-hidden', 'true');
      }
    });

    menu.insertBefore(template.content.cloneNode(true), menu.firstChild);
    menu.dataset.ibaUaeReady = 'true';
    return true;
  };

  const installUaeFooter = () => {
    const footer = document.querySelector('#t4s-footer');
    const template = document.querySelector('#iba-uae-footer-template');

    if (!footer || !template || footer.querySelector('.iba-uae-footer')) return false;

    footer.appendChild(template.content.cloneNode(true));
    footer.dataset.marketFooter = 'AE';
    return true;
  };

  const installUaeReviewAssets = () => {
    const section = document.querySelector('.iba-uae-reviews');
    if (!section || section.dataset.ibaReviewAssetsRequested === 'true') return false;

    const legacyGrid = section.querySelector('.iba-uae-review-grid');
    if (legacyGrid) {
      legacyGrid.classList.add('iba-uae-reviews__grid');
    }

    const stylesheetUrl = getUaeAssetUrl('iba-market-reviews-carousel.css');
    const scriptUrl = getUaeAssetUrl('iba-market-reviews.js');
    if (!stylesheetUrl || !scriptUrl) return false;

    section.dataset.ibaReviewAssetsRequested = 'true';

    if (!document.querySelector('link[data-iba-uae-reviews]')) {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = stylesheetUrl;
      stylesheet.dataset.ibaUaeReviews = 'true';
      document.head.appendChild(stylesheet);
    }

    if (!document.querySelector('script[data-iba-uae-reviews]')) {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = false;
      script.dataset.ibaUaeReviews = 'true';
      script.addEventListener(
        'error',
        () => {
          section.dataset.ibaReviewAssetsRequested = 'false';
          script.remove();
        },
        { once: true }
      );
      (document.body || document.head).appendChild(script);
    }

    return true;
  };

  const initialize = () => {
    try {
      installUaeMobileMenu();
    } catch (error) {}

    try {
      installUaeFooter();
    } catch (error) {}

    try {
      installUaeReviewAssets();
    } catch (error) {}
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  // One bounded fallback covers theme fragments rendered just after DOM ready.
  // No observer, redirect, reload, or recurring timer is used.
  window.setTimeout(initialize, 600);
})();